import TextBox, { TextBoxProps } from './TextBox';

export type { TextBoxProps };
export default TextBox;
